<template>
  <!-- dialog S&K -->
  <v-dialog v-model="dialogSyarat" width="auto">
    <v-card max-width="60vw">
      <v-card-text>
        <template v-for="syarat in syaratKetentuan" :key="syarat.sk_id">
          <syarat-ketentuan-item :syarat="syarat" :level="0"></syarat-ketentuan-item>
          <v-divider v-if="
            !syarat.sksub_id &&
            syaratKetentuan.indexOf(syarat) !== syaratKetentuan.length - 1
          " class="my-4" :thickness="1" opacity="1" color="base"></v-divider>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn @click="dialogSyarat = false"> Tutup </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SyaratKetentuanItem from "./SyaratKetentuanItem.vue";
export default {
  components: {
    SyaratKetentuanItem,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["update:dialog"],
  data() {
    return {
      syaratKetentuan: [],
      dialogSyarat: false,
    };
  },
  watch: {
    dialogSyarat(value) {
      this.$emit("update:dialog", value);
    },
    dialog(value) {
      if (value) {
        this.getSyaratKetentuan();
      }
    },
  },
  methods: {
    getSyaratKetentuan() {
      this.axios
        .get("info/syaratketentuan/get")
        .then((response) => {
          const data = response.data.response;
          this.syaratKetentuan = this.structuredSyaratKetentuan(data).data;
        })
        .finally(() => {
          this.dialogSyarat = true;
        });
    },

    structuredSyaratKetentuan(syaratKetentuan) {
      const temp = [];
      const blackList = [];

      const sortedData = [...syaratKetentuan].sort((a, b) => a.order - b.order);

      for (const syarat of sortedData) {
        const id = syarat.sk_id;
        const subSyarat = sortedData.filter((s) => s.sksub_id === id);

        if (subSyarat.length > 0) {
          blackList.push(...subSyarat.map((s) => s.sk_id));
          const checkSubSyarat = this.structuredSyaratKetentuan(subSyarat);
          syarat.contents = checkSubSyarat.data;
        }
        temp.push(syarat);
      }

      return {
        data: temp.filter((s) => !blackList.includes(s.sk_id)),
        blackList: blackList,
      };
    },
  },
};
</script>

<style></style>
